import type { ProjectTemplateDocument } from '@servicetim/shared';

export interface TemplateCount {
  label: string;
  count: number;
}

/** Content summary of a template document ("3 issue types, 12 fields, 2 workflows"). */
export function summarizeTemplate(doc: ProjectTemplateDocument): TemplateCount[] {
  const counts: TemplateCount[] = [
    { label: 'issue types', count: doc.issueTypes.length },
    { label: 'workflows', count: doc.workflows.length },
    { label: 'fields', count: doc.fields.length },
    { label: 'forms', count: doc.forms.length },
    { label: 'priorities', count: doc.priorities.length },
    { label: 'roles', count: doc.roles.length },
    { label: 'views', count: doc.views.length },
    { label: 'SLA policies', count: doc.slaPolicies.length },
    { label: 'canned responses', count: doc.cannedResponses.length },
  ];
  return counts.filter((c) => c.count > 0);
}

export const summaryText = (doc: ProjectTemplateDocument): string =>
  summarizeTemplate(doc)
    .map((c) => `${c.count} ${c.count === 1 ? c.label.replace(/s$/, '') : c.label}`)
    .join(', ');
